import type { CrmEvent } from "../types";
import { isSameDay } from "./calendarUtils";

/** "5 nov. 2026, 18:00 – 22:00", or with the end date when it ends another day. */
export const formatEventDate = (
  event: Pick<CrmEvent, "start_at" | "end_at">,
  locale: string,
): string => {
  const dateTime = new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeStyle: "short",
  });
  const start = new Date(event.start_at);
  if (!event.end_at) return dateTime.format(start);
  const end = new Date(event.end_at);
  const endText = isSameDay(start, end)
    ? formatEventTime(end, locale)
    : dateTime.format(end);
  return `${dateTime.format(start)} – ${endText}`;
};

export const formatEventTime = (date: Date, locale: string): string =>
  new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
